import React, { useEffect, useState } from "react";
import "../../styles/style.css";
import { Link } from "react-router-dom";

const NoLesson = () => {
  return (
    <div className="no-lesson-wrapper">
      <div className="no-lesson-info">
        <h1>
          NO NEW LESSONS
        </h1>
        <p>
            Go back to the previous page, or  check out the changelog to see the recent changes and additions.
        </p>
      </div>

      <div className="no-lesson-buttons">
        <button className="button-17">
          CHANGELOG
        </button>
      </div>
    </div>
  );
};

export default NoLesson;
